const fieldList = ()=>import("./views/fieldList.vue");

export default {
	// 字段设置
  path: "/fieldList",
  name: "fieldList",
  component: fieldList,
  meta: {
    root: "/inforMan"
  }
}



// WEBPACK FOOTER //
// ./src/core/modules/field/router.js